<template>
    <ul class="radio-button-list" data-id="message-subject-list" :class="{ inline: inline }">
        <li v-for="(item, index) in items" :key="index" :data-id="`list-item-${getItemId(item)}`">
            <a :class="{ active: isActive(item.value) }" @click="updateValue(item)">
                <input type="radio" :name="groupName" :value="item.value" />
                <label :for="groupName">{{ item.label }}</label>
            </a>
        </li>
    </ul>
</template>

<script lang="ts" setup>
import { ref, computed, watch } from 'vue';
import { ButtonListItem } from '@/features/shared/models/ButtonListItem';

const props = defineProps<{
    items: ButtonListItem[];
    group?: string;
    inline: boolean;
}>();

const emit = defineEmits(['update']);
const value = ref('');

watch(
    () => props.items,
    () => {
        value.value = '';
    }
);

const groupName = computed(() => {
    if (!props.group) {
        return 'default';
    }
    return props.group;
});

function isActive(val: string) {
    return value.value === val;
}

function updateValue(item: ButtonListItem) {
    value.value = item.value;
    emit('update', item);
}

function getItemId(item: any) {
    const label = item.label.indexOf(' ') > -1 ? item.label.slice(0, item.label.indexOf(' ')) : item.label;
    return `${item.group}-${label}`;
}
</script>

<style lang="scss">
.radio-button-list {
    margin: 0;
    padding: 0 !important;
    overflow: hidden;
    text-align: center;
    display: flex;
    align-items: stretch;
    justify-content: center;
    flex-wrap: wrap;

    label {
        cursor: pointer;
    }

    li {
        margin-bottom: 12px;
        padding-left: 6px;
        padding-right: 6px;
        width: 204px;
        list-style: none;
    }

    input {
        display: none;
    }

    a {
        text-decoration: none;
        font-family: 'open-sans-semi-bold', Arial, sans-serif;
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        background-color: #f2f2f2;
        transition: background-color 0.25s ease;
        color: #1f1f1f;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding: 15px 20px 14px;
        box-shadow:
            0 1px 3px rgb(0 0 0 / 20%),
            0 2px 2px rgb(0 0 0 / 12%),
            0 0 2px rgb(0 0 0 / 14%);

        &:hover {
            background-color: #dfdfdf;
        }

        &.active {
            background-color: #5c5c5c;
            transition: background-color 0.25s ease;
            color: #fff;
            box-shadow:
                0 4px 5px rgb(0 0 0 / 20%),
                0 3px 14px rgb(0 0 0 / 12%),
                0 8px 10px rgb(0 0 0 / 14%);
        }

        &.active:hover {
            background-color: #494949;
        }
    }
}

@media (max-width: 480px) {
    .radio-button-list {
        li {
            width: auto;
        }
    }
}
</style>
